import { useStyles } from '@webapps/styles';
import { PaginationNumbers, useAuth, useQuery, Modal, Loader } from '@webapps/reactjs-tech-components';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useFormik } from 'formik';
import { Button, Grid } from '@material-ui/core';
import FiltersAccounting from './components/FiltersAccounting';
import AccountingCard from './components/AccountingCard';
import { getRelationsByCFA, searchOpcoBillings } from '@webapps/business';
import AccountingChart from './components/AccountingChart';
import { useHistory } from 'react-router-dom';
import { ROUTES_PATH } from 'config/constants';
import ModalWithImage from 'components/ModalWithImage';
import theme from './theme';

const Accounting = () => {
  const { classes, global, cx } = useStyles(styles);
  const {
    images: { HourGlass },
  } = theme;
  const { idUser } = useAuth();


  const { state } = useLocation();
  const [studentsId, setStudentsId] = useState();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(8);
  const [showModal, setShowModal] = useState(true);
  const { push } = useHistory();

  const formik = useFormik({
    initialValues: {
      school: "",
      trainingLabel: "",
      studentName: "",
      opcos: "",
      billingStatus: "",
    },
  });

  const { data: { content: relationsList = [] } = {} } = useQuery(getRelationsByCFA, {
    key: ['relationsList'],
    variables: { id: idUser, size: 100, page: 0 },
    keepPreviousData: true
  });

  const { data: { content: billings = [], totalElements } = {}, refetch } = useQuery(searchOpcoBillings, {
    key: ['opcoBillings', size, page, formik?.values],
    variables: {
      id: idUser,
      schoolsId: formik?.values?.school?.id,
      trainingLabel: formik?.values?.trainingLabel,
      studentName: formik?.values?.studentName
        ? formik.values.studentName.trim().split(/\s+/).join(',')
        : null,
      opcos: formik?.values?.opcos,
      billingStatus: formik?.values?.billingStatus,
      size,
      page: page - 1
    },
    keepPreviousData: true
  });

  const handleCloseModal = () => {
    setShowModal(false);
    push(ROUTES_PATH.CFA_DASHBOARD);
  };

  return (
    <ModalWithImage
      open={showModal}
      onCancel={handleCloseModal}
      title='Page indisponible'
      subtitle='Cette page est temporairement indisponible.'
      actions={[
        {
          label: 'Ok 😢',
          onClick: handleCloseModal,
          type: 'validateButton'
        }
      ]}
      image={{
        src: HourGlass,
        alt: 'Page indisponible',
        height: 150
      }}
    />
  )
  //   <Modal
  //   open={showModal}
  //   onClose={handleCloseModal}
  //   onCancel={handleCloseModal}
  //   title="Page indisponible"
  //   onConfirm={handleCloseModal}
  // >
  //   <div
  //     style={{
  //       display: 'flex',
  //       flexDirection: 'column',
  //       alignItems: 'center',
  //       justifyContent: 'center',
  //       height: '100%',
  //     }}
  //   >
  //     <p>Cette page est temporairement indisponible.</p>
  //     <Button onClick={handleCloseModal}
  //       variant="contained"
  //       color="primary"
  //       style={{ marginTop: '20px' }}
  //       size="small"
  //       className={classes.button}
  //     >Ok 😢</Button>
  //   </div>
  // </Modal>

  return (
    <>
      <div className={cx(global.container, classes.container)}>
        {showModal ? <><AccountingChart state={state} />
          <div className={global.containerContent} >
            <div>
              <FiltersAccounting formik={formik} schools={relationsList.map(item => item.school).filter(school => school)} refetch={refetch} />
              <Grid className={global.paper} container>
                {billings?.length > 0 ? billings?.map((billing) => (
                  <Grid key={billing.id} item xs={12} sm={6} md={4} xl={3} style={{ padding: '0 20px 20px 0' }}  >
                    <AccountingCard info={billing} refetch={refetch} />
                  </Grid>
                )) : (
                  <div>
                    Aucune factures
                  </div>
                )}
              </Grid>
              <PaginationNumbers
                onChange={(newPage) => setPage(newPage)}
                page={page}
                pageCount={size}
                totalCount={totalElements}
              />
            </div>
          </div> </> : <Loader />}
      </div>
    </>
  );
};

const styles = ({ }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: "30px",
  }
});

export default Accounting;